import styled, { css } from "styled-components";
import { ImageStyled } from "../../../base/multimedia/image/styled.js";
import { FlexMixin } from "../../../../styles/common/mixins/helpers.styled.js";
import { DealsAlign, DealsPosition } from "./types.js";
export const Deals = styled.div.withConfig({
    displayName: "styled__Deals",
    componentId: "sc-ff00a8ad-0"
})`
	${FlexMixin({
    align: 'center'
})}
	background-color: ${({ theme  })=>theme.colors.status.offer};
	height: 80px;
	max-width: 280px;
	position: relative;
	z-index: ${({ theme  })=>theme.zIndex.low};

	${ImageStyled} {
		img {
			width: auto;
			height: 100%;
		}
	}

	${({ $position  })=>{
    if ($position === DealsPosition.top) {
        return css`
				position: absolute;
				top: 0;
			`;
    }
    if ($position === DealsPosition.bottom) {
        return css`
				position: absolute;
				bottom: 0;
			`;
    }
}}

	${({ $align  })=>{
    if ($align === DealsAlign.left) {
        return css`
				position: absolute;
				left: 15px;
			`;
    }
    if ($align === DealsAlign.center) {
        return css`
				margin: 0 auto;
			`;
    }
    if ($align === DealsAlign.right) {
        return css`
				position: absolute;
				right: 15px;
			`;
    }
}}
`;

//# sourceMappingURL=styled.js.map